export default {
  VIDEO: 'video',
  CHANNEL: 'channel',
  USER_NAME: 'username',
  PLAYLIST: 'playlist',
};



// WEBPACK FOOTER //
// ./src/shared/constants/channel-feed-types.js